<template>
  <el-row
    v-loading="false"
    :gutter="15"
  >
    <el-col :md="6">
      <List
        :enquiries="enquiries"
        @change="change"
      />
    </el-col>
    <el-col :md="18">
      <Details
        v-if="enquiries.length"
        :enquiry="enquiries[activeEnquiry]"
        :consignment="consignment"
      />
    </el-col>
  </el-row>
</template>
<script>
import List from '@/components/Application/Freight/Consignments/Enquiries/List'
import Details from '@/components/Application/Freight/Consignments/Enquiries/Details'
import Request, { GET } from '@/plugins/sdk/Request'
import CreateEnquiryDialog from '@/components/Application/Freight/Consignments/Enquiries/CreateDialog'
import Vue from 'vue'

export default {
  components: {
    List,
    Details
  },
  data () {
    return {
      actions: [
        {
          hidden: false,
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => {
            this.createEnquiry(this.consignment)
          }
        }
      ],
      consignment: null,
      isLoading: false,
      enquiries: [],
      activeEnquiry: 0,
      enquiryCreateDialogInstance: undefined,
      enquiryCreateDialogVisible: false
    }
  },
  created () {
    this.loadEnquiries()
  },
  methods: {
    change (val) {
      this.activeEnquiry = val
      this.consignment = null
      this.loadConsignment(this.activeEnquiry)
    },
    async loadConsignment (index) {
      this.isLoading = true

      this.$sdk.consignment.list(builder => {
        builder.filters = { 'con_full': this.enquiries[index].custom_fields.cf_consignment }
        builder.include = [
          'teams.account',
          'trackings',
          'service',
          'carrier',
          'items',
          'items.type'
        ]
      })
        .then(res => { this.consignment = res[0] })
        .finally(() => { this.isLoading = false })

      this.isLoading = false
    },
    createEnquiry (consignment) {
      const EnquiryCreateDialogClass = Vue.extend(CreateEnquiryDialog)

      this.enquiryCreateDialogInstance = new EnquiryCreateDialogClass({
        propsData: {
          consignment
        }
      })

      this
        .enquiryCreateDialogInstance
        .$on('destroy', () => {
          this.enquiryCreateDialogVisible = false
          this.loadConsignment()
        })

      this
        .enquiryCreateDialogInstance
        .$mount()

      this
        .$root
        .$el
        .appendChild(this.enquiryCreateDialogInstance.$el)

      this.enquiryCreateDialogVisible = true
    },
    async loadEnquiries () {
      const request = await (Object.assign(new Request(), {
        method: GET,
        _pathname: 'account/' + this.$route.params.accountId + '/enquiries'
      })).build()

      const response = await fetch(request)

      this.enquiries = await response.json()
      this.isLoading = false
    },
    setActiveEnquiry (index) {
      this.activeEnquiry = index
    }
  }
}
</script>
